// LA ENTRADA DE PLATFORM ADMIN ("Entrar" / "Ver como"), GUARDADA CON RESPALDO.
//
// Lissette, 2026-10-26: el vigía (vigiaDeEntrada.js) dijo "[al abrir: NO
// estaba]". La entrada no la borraba nadie: NUNCA llegaba a guardarse. La
// marca de la hora, que se guarda justo después, sí entraba. Lo que encaja es
// el almacenamiento del navegador (localStorage) LLENO: rechaza escribir algo
// nuevo, y el código de antes se tragaba el error sin decir nada.
//
// Ahora la entrada se guarda en localStorage y, si no cabe, en el almacenamiento
// de la PESTAÑA (sessionStorage, con su propio espacio aparte), que también
// sobrevive a la recarga. Leer mira los dos; borrar borra los dos. Si no cabe
// ni en uno ni en otro, se dice (la escritura devuelve null). Y cuando
// localStorage rechaza una escritura, se anota qué lo está llenando, para poder
// limpiarlo después.
//
// TODO lo que lee, escribe o borra la entrada pasa por aquí (AuthGate,
// deskte-full, PlatformAdminView): uno que leyera solo localStorage no vería
// una entrada guardada en el respaldo.

export const CLAVE_AGENCIA = 'deskte:impersonateAgencyId';
export const CLAVE_USUARIO = 'deskte:impersonateUserId';
export const CLAVE_MOTIVO = 'deskte:impersonateReason';
export const ALMACEN_LLENO_KEY = 'deskte:almacenLleno';

export function leerEntrada(clave) {
  try { const v = localStorage.getItem(clave); if (v) return v; } catch (_) { /* sigue */ }
  try { return sessionStorage.getItem(clave); } catch (_) { return null; }
}

/** ¿Hay una entrada guardada ("Entrar" o "Ver como"), en cualquiera de los dos sitios? */
export function hayEntrada(cual) {
  if (cual === 'agencia') return !!leerEntrada(CLAVE_AGENCIA);
  if (cual === 'usuario') return !!leerEntrada(CLAVE_USUARIO);
  return !!(leerEntrada(CLAVE_AGENCIA) || leerEntrada(CLAVE_USUARIO));
}

/** Las claves que más ocupan en localStorage, para saber qué lo llena. */
export function resumenDelAlmacen(almacen = (typeof localStorage !== 'undefined' ? localStorage : null)) {
  try {
    if (!almacen) return '';
    const filas = [];
    let total = 0;
    for (let i = 0; i < almacen.length; i++) {
      const k = almacen.key(i);
      const largo = ((k || '').length + String(almacen.getItem(k) || '').length) * 2; // bytes (UTF-16)
      total += largo;
      filas.push([k, largo]);
    }
    filas.sort((a, b) => b[1] - a[1]);
    const kb = (n) => `${Math.round(n / 1024)}KB`;
    return `total ${kb(total)} en ${filas.length} claves · ` + filas.slice(0, 3).map(([k, n]) => `${String(k).slice(0, 40)} ${kb(n)}`).join(', ');
  } catch (_) { return ''; }
}

function anotarAlmacenLleno(err) {
  try {
    sessionStorage.setItem(ALMACEN_LLENO_KEY, `${(err && err.name) || 'error'} · ${resumenDelAlmacen()}`.slice(0, 400));
  } catch (_) { /* ni eso cabe */ }
}

/**
 * Guarda la entrada. Devuelve dónde quedó: 'local', 'pestana' (el respaldo) o
 * null si no cupo en ningún sitio.
 */
export function guardarEntrada(clave, valor) {
  try {
    localStorage.setItem(clave, valor);
    if (localStorage.getItem(clave) === valor) {
      try { sessionStorage.removeItem(clave); } catch (_) { /* no había */ }
      return 'local';
    }
  } catch (err) {
    anotarAlmacenLleno(err);
  }
  try {
    sessionStorage.setItem(clave, valor);
    if (sessionStorage.getItem(clave) === valor) return 'pestana';
  } catch (_) { /* tampoco */ }
  return null;
}

export function borrarEntrada(clave) {
  try { localStorage.removeItem(clave); } catch (_) { /* nada */ }
  try { sessionStorage.removeItem(clave); } catch (_) { /* nada */ }
}
